import React from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import * as Screens from 'components/screens';
import * as Modules from 'components/modules';
import './index.css';
import './carousel.css?raw';
import './globalStyles.css?raw';

const App = ({ page }) => (
  <Modules.RootWrapper>
    <Helmet>
      <title>Great</title>
      <meta name="description" content="" />
    </Helmet>
    <Modules.Header />
    <Modules.Switcher />
    <Modules.Overlay />
    {page !== 'Home' && <Modules.KeyHandler />}
  </Modules.RootWrapper>
);

const mapStateToProps = state => ({
  page: state.page,
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js